import { Component, input } from '@angular/core';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [BadgeModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
})
export class BadgeComponent {
  readonly value = input('');
  readonly size = input<'large' | 'xlarge'>();
  readonly severity = input<'success' | 'warning' | 'info' | 'danger'>('info');
  readonly disabled = input(false);
  readonly round = input(true);
  readonly severityClass = input<badgeSeverity>('info');
}

export type badgeSeverity = 'secondary' | 'progress' | 'success' | 'warning' | 'info' | 'danger';
